module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "player"
    }
  }, [_c('abbr', {
    attrs: {
      "title": _vm.tokens['tit_restart']
    }
  }, [_c('button', {
    staticClass: "icon-btn restart",
    on: {
      "click": _vm.restart
    }
  })]), _c('abbr', {
    attrs: {
      "title": _vm.tokens['tit_pause_cont']
    }
  }, [_c('button', {
    staticClass: "icon-btn",
    class: {
      play: _vm.isPaused, pause: !_vm.isPaused
    },
    on: {
      "click": _vm.toggle
    }
  })]), _c('div', {
    staticClass: "track"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-634297ab"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vis/Player.vue
// module id = 429
// module chunks = 0